<favorite-toggle></favorite-toggle>

<!-- Favourites panel toggle -->
<button mat-icon-button (click)="openPanel()" #shortcutsOrigin>
    <mat-icon [svgIcon]="'heroicons_outline:bookmark-square'"></mat-icon>
</button>

<!-- Favourites panel -->
<ng-template #shortcutsPanel>
    <div
        class="fixed inset-0 flex flex-col overflow-hidden shadow-lg sm:static sm:inset-auto sm:w-[30rem] sm:min-w-[30rem] sm:rounded-2xl"
    >
        <!-- Header -->
        <div
            class="flex shrink-0 items-center bg-primary py-4 pl-6 pr-4 text-on-primary"
        >
            <div class="-ml-1 mr-3 sm:hidden">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon
                        class="text-current icon-size-5"
                        [svgIcon]="'heroicons_solid:x-mark'"
                    ></mat-icon>
                </button>
            </div>
            <div class="flex items-center text-lg font-medium leading-10">
                <span class="">Favourites</span>
                @if (mode === 'modify') {
                    <span class="ml-1">- Editing</span>
                }
            </div>
            <div class="ml-auto">
                <!-- View mode -->
                @if (mode === 'view') {
                    <!-- Enter 'modify' mode -->
                    <button
                        mat-icon-button
                        (click)="changeMode('modify')"
                        [matTooltip]="'Manage favourites'"
                    >
                        <mat-icon
                            class="text-current icon-size-5"
                            [svgIcon]="'heroicons_solid:pencil-square'"
                        ></mat-icon>
                    </button>
                }

                <!-- Modify mode -->
                @if (mode === 'modify') {
                    <!-- Enter 'view' mode -->
                    <button
                        mat-icon-button
                        (click)="changeMode('view')"
                        [matTooltip]="'Done'"
                    >
                        <mat-icon
                            class="text-current icon-size-5"
                            [svgIcon]="'heroicons_solid:check-circle'"
                        ></mat-icon>
                    </button>
                }
            </div>
        </div>
        <div
            class="bg-card relative -mb-px flex flex-auto flex-col overflow-y-auto sm:max-h-120"
        >
            <div
                class="favourites-drop-list flex flex-col divide-y"
                cdkDropList
                [cdkDropListData]="shortcuts"
                [cdkDropListDisabled]="mode !== 'modify'"
                (cdkDropListDropped)="drop($event)"
            >
                @for (shortcut of shortcuts; track shortcut.id) {
                    <div
                        class="favourite-row group bg-card relative overflow-hidden hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
                        cdkDrag
                        [cdkDragDisabled]="mode !== 'modify'"
                    >
                        @if (mode === 'modify') {
                            <div class="flex w-full items-center gap-2 px-4 py-4">
                                <button
                                    mat-icon-button
                                    cdkDragHandle
                                    class="favourite-drag-handle shrink-0"
                                    [matTooltip]="'Drag to reorder'"
                                >
                                    <mat-icon
                                        class="icon-size-5"
                                        [svgIcon]="'heroicons_solid:bars-3'"
                                    ></mat-icon>
                                </button>

                                <ng-container
                                    *ngTemplateOutlet="linkContent"
                                ></ng-container>

                                <button
                                    mat-icon-button
                                    class="shrink-0"
                                    [matTooltip]="'Edit favourite'"
                                    (click)="editShortcut($event, shortcut)"
                                >
                                    <mat-icon
                                        class="icon-size-5"
                                        [svgIcon]="'heroicons_solid:pencil-square'"
                                    ></mat-icon>
                                </button>
                                <button
                                    mat-icon-button
                                    class="shrink-0"
                                    [matTooltip]="'Remove favourite'"
                                    (click)="removeShortcut($event, shortcut)"
                                >
                                    <mat-icon
                                        class="icon-size-5"
                                        [svgIcon]="'heroicons_solid:x-mark'"
                                    ></mat-icon>
                                </button>
                            </div>
                        } @else if (!shortcut.useRouter) {
                            <a
                                class="flex w-full items-center gap-4 px-4 py-4 no-underline"
                                [href]="shortcut.link"
                            >
                                <ng-container
                                    *ngTemplateOutlet="linkContent"
                                ></ng-container>
                            </a>
                        } @else {
                            <a
                                class="flex w-full items-center gap-4 px-4 py-4 no-underline"
                                [routerLink]="shortcut.link"
                            >
                                <ng-container
                                    *ngTemplateOutlet="linkContent"
                                ></ng-container>
                            </a>
                        }

                        <ng-template #linkContent>
                            <div
                                class="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700"
                            >
                                <mat-icon
                                    class="z-10 icon-size-5"
                                    [svgIcon]="shortcut.icon"
                                ></mat-icon>
                            </div>
                            <div class="min-w-0 flex-1">
                                <div class="flex min-h-10 flex-col justify-center">
                                    <div
                                        class="truncate text-base font-medium leading-6 text-gray-900 dark:text-gray-100"
                                        [matTooltip]="shortcut.label"
                                    >
                                        {{ shortcut.label }}
                                    </div>
                                    @if (shortcut.description) {
                                        <div
                                            class="text-secondary mt-1 truncate text-sm leading-5"
                                            [matTooltip]="shortcut.description"
                                        >
                                            {{ shortcut.description }}
                                        </div>
                                    }
                                </div>
                            </div>
                        </ng-template>
                    </div>
                }
            </div>

            @if (!shortcuts || !shortcuts.length) {
                <div
                    class="flex flex-auto flex-col items-center justify-center px-8 py-12 sm:justify-start"
                >
                    <div
                        class="flex h-14 w-14 flex-0 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-600"
                    >
                        <mat-icon
                            class="text-primary-700 dark:text-primary-50"
                            [svgIcon]="'heroicons_outline:star'"
                        ></mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">
                        No favourites
                    </div>
                    <div
                        class="text-secondary mt-1 w-full max-w-60 text-center text-md"
                    >
                        Use the star button to save your current screen.
                    </div>
                </div>
            }
        </div>
    </div>
</ng-template>
